import { Prompt } from "react-router-dom";
import { connect } from "react-redux";

var CurrentUser = require("lib/account/CurrentUser");
var StudentAvatar = require("components/avatars/StudentAvatar");

@connect(
	(state, ownProps) => ({
		user: CurrentUser.get(),
	}),
	(dispatch, props) => ({}),
)

// @providePopulateData()

class PhotoBooth extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		if (props.width) {
			var width = props.width
		} else {
			var width = 400
		}
		this.state = {
			width: width, imageIndex: 0, taglineIndex: 0, avatarSize: 140, avatarPos: {top: "0px", left: "0px",}, minAvatarSize: 100
		};
	}

	renderBackground() {
		var imagePath = this.props.background
		return (
			<img style={{"width": "100%", "height": "100%", "zIndex": 0, "display":"inline-block"}} src={ imagePath} />
		)
	}

	renderOwl() {
		const top = this.props.avatarPos.top
		const left = this.props.avatarPos.left
		return (
			<div ref="avatar" id="boothAvatar" style={{"position": "absolute", "top": top, "left": left, "zIndex": 1000}}>
				<StudentAvatar student={this.props.user} maxWidth={this.props.avatarSize} disableAnimation={true}/>
			</div>
		)
	}

	renderImage() {
		const width = this.state.width * 0.89
		const height = width 
		var background = this.renderBackground()
		var owl = this.renderOwl()
		return (
			<div ref="image" id="boothImage" className="image" style={{"width": width, "height": height, "backgroundColor": "black", "position": "relative", "overflow": "hidden"}}>
				{ background }
				{ owl }
			</div>
		)
	}

	renderCaption() {
		return (
			<div style={{"textAlign": "center", "paddingTop": "12px", "paddingBottom": "12px", "fontSize": "120%"}}>
				{ this.props.caption }
			</div>
		)	
	}

	renderPolaroid() {
		var width = parseInt(this.state.width)
		var height = this.state.width * 1.2
		var image = this.renderImage()
		var tagLine = this.renderCaption()
		var padding = width * 0.06

		return (
			<div id="polaroid" ref="polaroid" style={{width: width, height: height, padding: padding, backgroundColor: "white", margin: "auto"}}>
				<div className="inner">
					{ image }
					{ tagLine }
				</div>
			</div>
		)
	}

	placeOwlCenter() {
		const owlSize = this.getRefSize(this.refs.avatar)
		const imageSize = this.getRefSize(this.refs.image)
		const owlWMidePoint = owlSize.w / 2.0
		const owlHMidePoint = owlSize.h / 2.0
		const imageWMidePoint = imageSize.w / 2.0
		const imageHMidePoint = imageSize.h / 2.0
		this.setState({avatarPos: {top: imageHMidePoint - owlHMidePoint, left: imageWMidePoint - owlHMidePoint}})
	}

	getRefSize(ref) {
		const width = $(ref).width();
		const height = $(ref).height();
		return { w: width, h: height };
	}

	render() {
		var polaroid = this.renderPolaroid()
		return(
			<div className="PhotoBooth" ref="output" style={{"backgroundColor": "black"}}>
				{ polaroid }
			</div>

		)
 	}

 	componentDidMount() {
 		this.props.placeOwlCenter()
 	}
};

module.exports = PhotoBooth;



// WEBPACK FOOTER //
// ./modules/components/games/PhotoBooth.js